import { FC } from "react";
import { Box, Group, Switch, Text } from "@mantine/core";
import { FilterComponentProps } from ".";
import { DATA_SOURCE_LABEL_MAP } from "../consts";

/**
 * EIS-1088: "Source" map filter -- one toggle per Winback_practitioners.data_source
 * value, all on by default. Follows the StatusFilter / SpecialtyTypeFilter
 * Switch.Group convention; the Switch VALUE is the raw wire data_source and the
 * visible label is the friendly name (Direct / Badger / Distributor / ...).
 */
const SourceFilter: FC<FilterComponentProps> = ({
  onFilterControlChange,
  filterControl
}) => {
  return (
    <Box mt="xl" ml={10} mr={5} h="85%" style={{ overflowY: "scroll" }}>
      <Switch.Group
        value={filterControl?.dataSource || undefined}
        onChange={(v) => onFilterControlChange({
          ...filterControl,
          dataSource: v,
        })}>
        {Array.from(DATA_SOURCE_LABEL_MAP.entries()).map(([dataSource, label], index) => (
          <Group justify="space-between" my="sm" key={index}>
            <Text fz="sm" fw="bold">
              {label}
            </Text>
            <Switch
              value={dataSource}
              data-testid={`map-filter-source-switch-${dataSource}`}
            />
          </Group>
        ))}
      </Switch.Group>
    </Box>
  );
};

export default SourceFilter;
